import { render, staticRenderFns } from "./excelExportPubl.vue?vue&type=template&id=2236144e"
import script from "./excelExportPubl.vue?vue&type=script&lang=js"
export * from "./excelExportPubl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports